/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertFinancialProfileAppRequest} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'
import {UpsertFinancialProfileAppResponse} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'


export const upsertFinancialProfileApp = (request: UpsertFinancialProfileAppRequest, options?: CashRequestOptions) => post<UpsertFinancialProfileAppRequest, UpsertFinancialProfileAppResponse>("/2.0/cash/upsert-financial-profile-app", request, {...options, rejectOnError: true })